import MessageService from '../../services/MessageService'

const state = () => ({
    loadingMessages: false,
    message: null,
    messages: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_message: false
})
  
const mutations = {
    SET_MESSAGE: (state, payload) => {
        state.message = payload
    },
    SET_MESSAGES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.messages = payload.itens
        }else{
            state.messages = [...payload.itens, ...state.messages]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_MESSAGES: (state, payload) => {
        state.loadingMessage = payload
    },
    SET_SHOW_MODAL_MESSAGE: (state, payload) => {
        state.show_modal_new_message = payload
    },
}

const actions = {
    async fetchMessage({commit}, id){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const response = await MessageService.getOne(id);
            commit('SET_MESSAGE', response.data)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchMessages({commit}, params = {}){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'createdAt', column: 'createdAt', sort: 'ASC' } , UserId = '', numberPhone = '', senderPhone = '', recipientId = '' } = params;
            const response = await MessageService.get(keyword, pageNumber, pageSize, order, UserId, numberPhone, senderPhone, recipientId);
            commit('SET_MESSAGES', response.data)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchMessagesByUsers({commit}, params = {}){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'createdAt', column: 'sentAt', sort: 'DESC' } , UserId = '', numberPhone = '', senderPhone = '', recipientId = '' } = params;
            const response = await MessageService.getByUser(keyword, pageNumber, pageSize, order, UserId, numberPhone, senderPhone, recipientId);
            commit('SET_MESSAGES', response.data)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createMessage({commit}, data){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const response = await MessageService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_MESSAGE', false)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeMessage({commit}, data){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const response = await MessageService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getMessage: state => state.message,
    getMessages: state => state.messages,
    getLoadingMessage: state => state.loadingMessage,
    getShowModalNewMessage: state => state.show_modal_new_message
}

export default {
    state,
    getters,
    mutations,
    actions
};